export default __webpack_public_path__ + "static/media/WM0270.34I-40777_-24095_0.d4b1be81.jpg";